import { Box, Flex, Text } from "@chakra-ui/react";
// import SvgIcAgreements from "assets/svg/SvgIcAgreements";
// import SvgIcClaims from "assets/svg/SvgIcClaims";
import { CardInfo } from "components/CardInfo";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import { toaster } from "components/ui/toaster";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { api } from "services/api";
import utils from "utils";
import storage from "utils/storage";

const items = [
  {
    key: "Agreements",
    label: "Agreements",
    route: "agreements",
    count: " ",
    countDetail: " ",
    buttonTRData: { imgIc: "./img/img-ic-agreements.png", route: "agreements" },
    buttonBRData: {
      label: "Create New",
      route: "agreementsadd",
    },
    chartData: {
      data: [],
      series: [{ name: "value", color: "red" }],
    },
  },
  {
    key: "Invoices",
    label: "Invoices",
    route: "invoices",
    count: " ",
    countDetail: " ",
    buttonTRData: { imgIc: "./img/img-ic-invoices.png", route: "invoices" },
    // buttonBRData: {
    //   label: "Create Invoice",
    //   route: "invoiceadd",
    // },
    chartData: {
      data: [],
      series: [{ name: "value", color: "red" }],
    },
  },
  {
    key: "Claims",
    label: "Claims",
    route: "claims",
    count: " ",
    countDetail: " ",
    buttonTRData: { imgIc: "./img/img-ic-claims.png", route: "claims" },
    // buttonBRData: {
    //   label: "Create Claim",
    //   route: "claimsadd",
    // },
    chartData: {
      data: [],
      series: [{ name: "value", color: "text" }],
    },
  },
  {
    key: "Accounts",
    label: "Accounts",
    route: "manageusers",
    count: " ",
    countDetail: " ",
    buttonTRData: { imgIc: "./img/img-ic-accounts.png", route: "accounts" },
    // buttonBRData: {
    //   label: "Create Invoice",
    //   route: "invoiceadd",
    // },
    chartData: {
      data: [],
      series: [{ name: "value", color: "red" }],
    },
  },
  // {
  //   key: "Documents",
  //   label: "Documents",
  //   route: "documents",
  //   count: " ",
  //   countDetail: " ",
  //   buttonTRData: { imgIc: "./img/img-ic-documents.png", route: "documents" },
  //   // buttonBRData: {
  //   //   label: "Create Invoice",
  //   //   route: "invoiceadd",
  //   // },
  //   chartData: {
  //     data: [],
  //     series: [{ name: "value", color: "red" }],
  //   },
  // },
  // {
  //   key: "Buildmyplan",
  //   label: "Build My Plan",
  //   count: 150,
  //   countDetail: "+9% from last month",
  //   buttonTRData: {
  //     imgIc: "./img/img-ic-buildmyplan.png",
  //     route: "buildmyplan",
  //   },
  //   // buttonBRData: {
  //   //   label: "Create Invoice",
  //   //   route: "invoiceadd",
  //   // },
  //   chartData: {
  //     data: [
  //       { value: 10 },
  //       { value: 16 },
  //       { value: 19 },
  //       { value: 15 },
  //       { value: 12 },
  //       { value: 15 },
  //       { value: 10 },
  //       { value: 18 },
  //     ],
  //     series: [{ name: "value", color: "red" }],
  //   },
  // },
  {
    key: "Manager",
    label: "Manage",
    route: "manage",
    buttonTRData: { imgIc: "./img/img-ic-manager.png", route: "manage" },
    buttonList: [
      {
        key: "Payment Out",
        label: "Payment Out",
        bgClr: "",
        route: "paymentsout",
      },
      {
        key: "Payment In",
        label: "Payment In",
        bgClr: "",
        route: "paymentsreceived",
      },
      // {
      //   key: "Covered Parts",
      //   label: "Covered Parts",
      //   bgClr: "",
      //   route: "covertypes",
      // },
      {
        key: "Schedule",
        label: "Schedule",
        bgClr: "",
        route: "schedule",
      },
      {
        key: "Claims Limits",
        label: "Claims Limits",
        bgClr: "fontdark",
        route: "claimlimits",
      },
      {
        key: "Persmissions",
        label: "Persmissions",
        bgClr: "fontdark",
        route: "permissionprofiles",
      },
    ],
  },
  // {
  //   key: "home",
  //   label: "Total Users Logged in:",
  //   count: " ",
  //   countDetail: " ",
  //   buttonTRData: {
  //     imgIc: "./img/img-ic-home.png",
  //     route: "home",
  //   },
  //   // buttonBRData: {
  //   //   label: "Create Invoice",
  //   //   route: "invoiceadd",
  //   // },
  //   chartData: {
  //     data: [],
  //     series: [{ name: "value", color: "red" }],
  //   },
  // },
];

// const itemsOg = [
//   {
//     key: "Agreements",
//     label: "Agreements",
//     route: "agreements",
//     count: 150,
//     countDetail: "+9% from last month",
//     buttonTRData: { imgIc: "./img/img-ic-agreements.png", route: "agreements" },
//     buttonBRData: {
//       label: "Create New",
//       route: "agreementsadd",
//     },
//     chartData: {
//       data: [
//         { value: 10 },
//         { value: 16 },
//         { value: 19 },
//         { value: 15 },
//         { value: 12 },
//         { value: 15 },
//         { value: 10 },
//         { value: 18 },
//       ],
//       series: [{ name: "value", color: "red" }],
//     },
//   },
//   {
//     key: "Invoices",
//     label: "Invoices",
//     route: "invoices",
//     count: 150,
//     countDetail: "+9% from last month",
//     buttonTRData: { imgIc: "./img/img-ic-invoices.png", route: "invoices" },
//     // buttonBRData: {
//     //   label: "Create Invoice",
//     //   route: "invoiceadd",
//     // },
//     chartData: {
//       data: [
//         { value: 50 },
//         { value: 60 },
//         { value: 70 },
//         { value: 30 },
//         { value: 10 },
//         { value: 22 },
//         { value: 60 },
//         { value: 50 },
//       ],
//       series: [{ name: "value", color: "red" }],
//     },
//   },
//   {
//     key: "Claims",
//     label: "Claims",
//     route: "claims",
//     count: 150,
//     countDetail: "+9% from last month",
//     buttonTRData: { imgIc: "./img/img-ic-claims.png", route: "claims" },
//     // buttonBRData: {
//     //   label: "Create Claim",
//     //   route: "claimsadd",
//     // },
//     chartData: {
//       data: [
//         { value: 10 },
//         { value: 16 },
//         { value: 19 },
//         { value: 15 },
//         { value: 12 },
//         { value: 15 },
//         { value: 10 },
//         { value: 18 },
//       ],
//       series: [{ name: "value", color: "text" }],
//     },
//   },documents
//   {
//     key: "Accounts",
//     label: "Accounts",
//     route: "manageusers",
//     count: 150,
//     countDetail: "+9% from last month",
//     buttonTRData: { imgIc: "./img/img-ic-accounts.png", route: "accounts" },
//     // buttonBRData: {
//     //   label: "Create Invoice",
//     //   route: "invoiceadd",
//     // },
//     chartData: {
//       data: [
//         { value: 10 },
//         { value: 16 },
//         { value: 19 },
//         { value: 15 },
//         { value: 12 },
//         { value: 15 },
//         { value: 10 },
//         { value: 18 },
//       ],
//       series: [{ name: "value", color: "red" }],
//     },
//   },
//   {
//     key: "Documents",
//     label: "Documents",
//     route: "documents",
//     count: 150,
//     countDetail: "+9% from last month",
//     buttonTRData: { imgIc: "./img/img-ic-documents.png", route: "documents" },
//     // buttonBRData: {
//     //   label: "Create Invoice",
//     //   route: "invoiceadd",
//     // },
//     chartData: {
//       data: [
//         { value: 10 },
//         { value: 16 },
//         { value: 19 },
//         { value: 15 },
//         { value: 12 },
//         { value: 15 },
//         { value: 10 },
//         { value: 18 },
//       ],
//       series: [{ name: "value", color: "red" }],
//     },
//   },
//   // {
//   //   key: "Buildmyplan",
//   //   label: "Build My Plan",
//   //   count: 150,
//   //   countDetail: "+9% from last month",
//   //   buttonTRData: {
//   //     imgIc: "./img/img-ic-buildmyplan.png",
//   //     route: "buildmyplan",
//   //   },
//   //   // buttonBRData: {
//   //   //   label: "Create Invoice",
//   //   //   route: "invoiceadd",
//   //   // },
//   //   chartData: {
//   //     data: [
//   //       { value: 10 },
//   //       { value: 16 },
//   //       { value: 19 },
//   //       { value: 15 },
//   //       { value: 12 },
//   //       { value: 15 },
//   //       { value: 10 },
//   //       { value: 18 },
//   //     ],
//   //     series: [{ name: "value", color: "red" }],
//   //   },
//   // },
//   {
//     key: "Manager",
//     label: "Manage",
//     route: "manage",
//     buttonTRData: { imgIc: "./img/img-ic-manager.png", route: "manage" },
//     buttonList: [
//       {
//         key: "Payment Out",
//         label: "Payment Out",
//         bgClr: "",
//         route: "paymentsout",
//       },
//       {
//         key: "Payment In",
//         label: "Payment In",
//         bgClr: "",
//         route: "paymentsreceived",
//       },
//       {
//         key: "Covered Parts",
//         label: "Covered Parts",
//         bgClr: "",
//         route: "covertypes",
//       },
//       {
//         key: "Schadule",
//         label: "Schadule",
//         bgClr: "",
//         route: "schedule",
//       },
//       {
//         key: "Claims Limits",
//         label: "Claims Limits",
//         bgClr: "fontdark",
//         route: "claimlimits",
//       },
//       {
//         key: "Persmissions",
//         label: "Persmissions",
//         bgClr: "fontdark",
//         route: "permissionprofiles",
//       },
//     ],
//   },
//   {
//     key: "home",
//     label: "Total Users Logged in:",
//     count: 190,
//     countDetail: "+9% from last month",
//     buttonTRData: {
//       imgIc: "./img/img-ic-home.png",
//       route: "home",
//     },
//     // buttonBRData: {
//     //   label: "Create Invoice",
//     //   route: "invoiceadd",
//     // },
//     chartData: {
//       data: [
//         { value: 10 },
//         { value: 26 },
//         { value: 49 },
//         { value: 65 },
//         { value: 12 },
//         { value: 15 },
//         { value: 55 },
//         { value: 3 },
//       ],
//       series: [{ name: "value", color: "red" }],
//     },
//   },
// ];

// const calPer = (totalcount, filtercount) => {
//   let previous_total = totalcount - filtercount;
//   let percentage_increase = (filtercount / previous_total) * 100;
//   let percentage_increaseStr = parseFloat(percentage_increase).toFixed(2);

//   if (percentage_increase > 999) {
//     percentage_increaseStr = "999+";
//   } else if (percentage_increase < -999) {
//     percentage_increaseStr = "-999+";
//   }
//   percentage_increaseStr += "% ";

//   if (percentage_increase >= 0) {
//     percentage_increaseStr += "increased";
//   } else {
//     percentage_increaseStr += "decrease";
//   }

//   return percentage_increaseStr;
// };

function Home() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState();
  const [dealers, setDealers] = useState();
  const [datestart, setDatestart] = useState(
    storage.get("appcatch")?.home_datestart ||
      utils.dateToDateInput(
        new Date(new Date().setDate(new Date().getDate() - 7))
      )
  );
  const [dateend, setDateend] = useState(
    storage.get("appcatch")?.home_dateend || utils.dateToDateInput(new Date())
  );
  const [dealerid, setDealerid] = useState();
  const userData = useSelector((state) => state.userData);
  const dispatch = useDispatch();

  const ismobile = useCheckMobileScreen();
  const cardMinW = ismobile ? "15rem" : "30rem";

  const onDealersChange = (data) => {
    console.log("onDealersChange data", data);
    setDealers(data?.list ? [...data.list] : []);
    setDealerid(data?.item?.data?.dealerid);

    const appcatch = storage.get("appcatch") || {};
    appcatch.home_dealerid = data?.item?.data?.dealerid;
    storage.set("appcatch", appcatch);
  };

  const getHomeData = async () => {
    console.log("getHomeData");

    if (!(datestart && dateend && dealerid)) {
      return;
    }
    setIsLoading(true);
    const l2 = JSON.parse(JSON.stringify(items));

    const res = await api.getHomeData({
      datestart,
      dateend,
      dealerid,
    });

    console.log("getHomeData res", res);

    if (res?.status === 200) {
      l2[0].chartData.data = res?.data?.policy?.data || [];
      l2[0].count = res?.data?.policy?.filtered || 0;
      // l2[0].countDetail = calPer(
      //   res?.data?.policy?.total,
      //   res?.data?.policy?.filtered
      // );

      l2[1].chartData.data = res?.data?.invoices?.data || [];
      l2[1].count = res?.data?.invoices?.filtered || 0;
      // l2[1].countDetail = calPer(
      //   res?.data?.invoices?.total,
      //   res?.data?.invoices?.filtered
      // );

      l2[2].chartData.data = res?.data?.claims?.data || [];
      l2[2].count = res?.data?.claims?.filtered || 0;
      // l2[2].countDetail = calPer(
      //   res?.data?.claims?.total,
      //   res?.data?.claims?.filtered
      // );

      l2[3].chartData.data = res?.data?.users?.data || [];
      l2[3].count = res?.data?.users?.filtered || 0;
      // l2[3].countDetail = calPer(
      //   res?.data?.users?.total,
      //   res?.data?.users?.filtered
      // );

      let l3 = [];

      if (userData?.userid !== 22) {
        l3.push(l2[0]);
        l3.push(l2[1]);
        l3.push(l2[2]);
        l3.push(l2[4]);
      } else {
        l3 = l2;
      }

      // l2[4].count = res?.data?.documents || 0;
      // l2[6].count = res?.data?.loginuser || 0;

      setList(l3);
    } else {
      setList([]);
      toaster.create({
        title: res?.message,
        type: "error",
      });
    }

    setIsLoading(false);
  };

  const onChangeDatestart = (v) => {
    setDatestart(v);
    const appcatch = storage.get("appcatch") || {};
    appcatch.home_datestart = v;
    storage.set("appcatch", appcatch);
  };

  const onChangeDateend = (v) => {
    setDateend(v);

    const appcatch = storage.get("appcatch") || {};
    appcatch.home_dateend = v;
    storage.set("appcatch", appcatch);
  };

  useEffect(() => {
    getHomeData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datestart, dateend, dealerid]);

  useEffect(() => {
    const appcatch = storage.get("appcatch") || {};
    // const cb401 = async () => {
    //   await utils.logout({ dispatch, setUserData });
    // };
    utils.getDealers({
      setIsLoading,
      action: "useState",
      onDealersChange,
      defaultVal: appcatch?.home_dealerid,
      // cb401,
    });
  }, [dispatch]);

  // if (!list || list.length === 0 || !list[0]) return null;

  // return <CardInfo {...list[0]} key={list[0].key} />;

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Home"} isLoading={isLoading} />
      {/* <iframe src={YourUrlToThePDF || ""}></iframe> */}
      {/* <Flex
        flex={1}
        // malistxW={"26rem"}
        direction={"column"}
        overflow={'hidden'}
        gap={"0.6rem"}
      > */}
      <Flex
        wrap={"wrap"}
        justifyContent="start"
        gap={"1rem"}
        pb="1rem"
        alignItems={"center"}
      >
        <InputComp
          type={"dropdown"}
          items={dealers}
          onChange={onDealersChange}
          // keyname={""}
          placeholder={"Select Account"}
        />
        {/* <Flex gap={"0.5rem"} alignItems={'center'}> */}
        <InputComp
          type={"date"}
          placeholder={"Select Date"}
          onChange={onChangeDatestart}
          value={datestart}
        />
        <Text>{" To "}</Text>
        <InputComp
          type={"date"}
          placeholder={"Select Date"}
          onChange={onChangeDateend}
          value={dateend}
        />
        {/* </Flex> */}
      </Flex>

      {/* <Flex
        display={'flex'}
        // flex={1}
        // overflow={"auto"}
        // overflowX={"hidden"}
        // direction={"column"}
        wrap={"wrap"}
        gap={"1rem"}
        // p={"2rem"}
        // alignItems={"flex-start"}
        // justifyContent={"flex-start"}
        // alignSelf={"flex-start"}
      >  */}
      <Box
        display="grid"
        gap="1rem"
        gridTemplateColumns={`repeat(auto-fit, minmax(${cardMinW}, 1fr))`}
        overflow={"scroll"}
        pr="0.5rem"
        flex={1}
        pt={"5px"}
      >
        {list?.map((item) => (
          <CardInfo {...item} key={item?.key} />
        ))}
      </Box>
      {/* </Flex> */}
      {/* </Flex> */}
      <Box
        pt={"1rem"}
        gapX={"0.5rem"}
        _before={{
          fontSize: "xs",
          content:
            '"Please feel free to contact us if you have any questions or enquiries: "',
        }}
        _after={{
          fontSize: "xs",
          color: "textv2.brand",
          content: `" ${utils.getUserCustomData({
            userData: userData,
            key: "footer",
          })}"`,
        }}
      >
        {/* <Text fontSize={'sm'} color={'fontdark'}> */}

        {/* </Text> */}
        {/* <Text fontSize={'sm'} color={'primary'}> */}
        {/* Office: 01244 378 544 / admin@auwarranties.co.uk */}
        {/* </Text> */}
      </Box>
    </Flex>
  );
}

export default Home;
